import React, { createContext, useContext } from "react";

/**
 * Whether the customize view is editing the PLAYBOOK itself rather than
 * configuring an experience from it.
 *
 * Config cards are rendered by id (`CONFIG_CARDS`) and so take no props; this
 * is how the few that hold experience-only controls learn to dim them. Defaults
 * to `false`, which is what the experience-edit page's cards want — they are
 * never in playbook-edit mode.
 */
const PlaybookEditModeContext = createContext(false);

export const PlaybookEditModeProvider: React.FC<{
  isEditingPlaybook: boolean;
  children: React.ReactNode;
}> = ({ isEditingPlaybook, children }) => (
  <PlaybookEditModeContext.Provider value={isEditingPlaybook}>
    {children}
  </PlaybookEditModeContext.Provider>
);

export const usePlaybookEditMode = () => useContext(PlaybookEditModeContext);
